import "./App.css";
import NavBar from "./Components/NavBar";
import Forcaste from "./Components/Forcaste";

function App() {
  return (
    <div className="container">
      <NavBar />
      
    </div>
  );
}

export default App;
